import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { useEffect } from "react";
import { Loading } from "djuno-design";
import { useParams } from "react-router-dom";
import {
  getAiNotebookAsync,
  selectAiNotebook,
  selectAiNotebookLoading,
} from "../../../../store/ai/notebooks/notebookSlice";
import { Helmet } from "react-helmet";
import {
  selectLogin,
  selectOnStageEnv,
} from "../../../../store/auth/authSlice";
import Iframe from "../../../general/Iframe";

const AiCodeEditorTab = () => {
  const { notebookId } = useParams();

  const dispatch = useAppDispatch();

  const notebook = useAppSelector(selectAiNotebook);
  const notebookLoading = useAppSelector(selectAiNotebookLoading);

  const activeEnv = useAppSelector(selectOnStageEnv);
  const authUser = useAppSelector(selectLogin);

  useEffect(() => {
    if (!notebook) {
      if (notebookId) {
        dispatch(getAiNotebookAsync({ id: notebookId }));
      }
    }
  }, [dispatch, notebook, notebookId]);

  if (notebookLoading) {
    return <Loading />;
  }

  return (
    <>
      <Helmet>
        <title>AI Notebooks</title>
        <meta name="description" content="" />
      </Helmet>

      <>
        {/* <div className="flex flex-col gap-3">
          <Typography.Title level={5} className="!mb-0">
            Attach data containers
          </Typography.Title>

          <div className="flex items-center gap-2">
            <Button
              uiType="primary"
              onClick={() => dispatch(handleSynchronisation({ status: true }))}
              className="group"
            >
              Global data synchronisation
            </Button>
          </div>
        </div> */}

        <div className="mt-5 w-full">
          <Iframe
            serviceName={notebook?.spec.name}
            url={`${
              import.meta.env.VITE_MODE === "develop"
                ? import.meta.env.VITE_BACK_END_URL
                : "/"
            }v1/environments/${activeEnv?.Id}/ai-lab-proxy/${
              notebook?._id
            }/?folder=/workspace`} //?token=${authUser?.JwtToken}
          />
          {/* <iframe
            // src="https://8453c4d1-6f56-41eb-b85a-a6d42d508c64.notebook.bhs.ai.cloud.ovh.net/?folder=/workspace"
            src={`https://api.djuno.cloud/v1/environments/${activeEnv?.Id}/ai-lab-proxy/1948/?folder=/workspace`} //?token=${authUser?.JwtToken}
            className="w-full h-[calc(100vh-200px)]"
            title="AI Notebook"
          ></iframe> */}
        </div>
      </>
    </>
  );
};
export default AiCodeEditorTab;
